<template>
  <Transition name="fade">
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div v-if="filteredComments.length == 0" class="mx-2 h-auto max-w-2xl max-h-full bg-white shadow-lg rounded-lg text-center">
        <div class="w-full text-right sticky top-0 right-0 pr-1">
          <button aria-label="close" class="text-xl text-gray-500" @click.prevent="close">×</button>
        </div>

        <div class="w-full h-auto max-h-full overflow-auto">
            <div class="mt-5 mb-8">
                <div
                    class="relative flex flex-col mb-0 px-4 py-1"
                >
                    <div class="clearfix">
                        <div class="w-auto mx-1 my-1 p-2 rounded-lg">
                            <div class="w-auto text-center text-gray-700">No hay mensajes en el chat</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>  
      </div>

      <div v-if="filteredComments.length>0" class="mx-2 w-full h-auto max-w-2xl max-h-full bg-white shadow-lg rounded-lg p-8 overflow-auto">
        <div class="w-full text-right sticky top-0 right-0 pr-0">
            <button aria-label="close" class="text-xl text-gray-500" @click.prevent="close">×</button>
        </div>

        <div class="w-full max-h-full pr-4 pl-4">
            <div class="w-full">
              <div class="flex w-1/2 text-left text-xs">
                  <div
                      v-if="alert.status === 'ABIERTA'"
                      class="px-3 py-1 rounded-full border-2 border-red-700 text-white bg-red-500 tracking-widest font-bold"
                  >{{ alert.status }}</div>
                  <div
                      v-if="alert.status === 'ASIGNADA'"
                      class="px-3 py-1 rounded-full border-2 border-orange-700 text-white bg-orange-500 tracking-widest font-bold"
                  >{{ alert.status }}</div>
                  <div
                      v-if="alert.status === 'ATENDIDA'"
                      class="px-3 py-1 rounded-full border-2 border-green-700 text-white bg-green-500 tracking-widest font-bold"
                  >{{ alert.status }}</div>
                  <div
                      class="px-3 py-1 text-black p-8"
                  >{{ alert.fecha_alerta | moment('DD/MM/YYYY hh:mm a')}}</div>
              </div>
            </div>

            <div class="mt-10 mb-8">
                <div
                    v-for="comment in filteredComments"
                    :key="comment.id"
                    class="relative flex flex-col mb-0 px-4 py-1"
                >
                    <div class="clearfix">
                        <div v-bind:class="[comment.user_type === 'authority' ? 'float-right bg-green-300' : 'float-left bg-gray-300']" class="w-auto mx-1 my-1 p-2 rounded-lg"
                            style="max-width: 75%">
                            <div class="w-auto text-left text-gray-700">{{ comment.message }}</div>
                            <div
                                class="w-auto text-right text-xs text-gray-800"
                            >{{ comment.date | moment('DD/MM/YYYY hh:mm a') }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import { backend_url } from "../config/url.config.ts";
import axios from "axios";
import moment from "moment";

export default {
  name: "event-comments-modal",
  data() {
    return {
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      },
      maxStars: 5,
      filter: "all",
      config: {
        headers: {
            "x-access-token": localStorage.getItem("accessToken")
        }
      },
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean
    },
    chartList: {
      required: true
    },
    alert: {
      required: true
    },
  },
  watch: {
    showing(value) {
      if (value) {
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    }
  },
  methods: {
    close() {
      this.filter = "all";
      this.$emit("close");
    }
  },
  computed: {
    filteredComments() {
      return this.chartList;
    }
  }
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>